module.exports = __webpack_public_path__ + "static/4-a5a9e850f1d5a1e0e7410a57ee84c8ed.jpg";